import { useState } from "react";
import "./faq.css";

export default function FAQ() {
  const faqData = [
    {
      question: "How long does it take to develop a website?",
      answer: "A standard business website typically takes 4-6 weeks. However, custom enterprise solutions or complex E-commerce platforms can span 3-5 months depending on the feature set and integrations required."
    },
    {
      question: "What technologies do you use for development?",
      answer: "We specialize in the MERN stack (MongoDB, Express, React, Node.js) for high-performance apps, alongside WordPress and Shopify for rapid, scalable CMS solutions."
    },
    {
      question: "Do you provide ongoing support?",
      answer: "Absolutely. We offer flexible maintenance packages that include security patches, regular backups, performance tuning, and content updates to keep your site running at peak efficiency."
    }
  ];

  return (
    <section className="faq-section py-5">
      <div className="container">
        <div className="row gy-5 align-items-center">
          
          {/* Left Side: Brand Visual */}
          <div className="col-lg-5">
            <div className="faq-visual">
              <div className="accent-blob"></div>
              <img 
                src="./images/Q.jpg" 
                alt="Support" 
                className="img-fluid rounded-4 shadow-lg main-faq-img"
              />
              <div className="floating-support-card">
                <i className="bi bi-chat-dots-fill"></i>
                <div>
                  <strong>24/7 Support</strong>
                  <p className="mb-0">We're always here.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side: Accordion */}
          <div className="col-lg-7 ps-lg-5">
            <div className="faq-header mb-4">
              <span className="badge rounded-pill bg-soft-magenta px-3 py-2 mb-2">QUESTIONS</span>
              <h2 className="display-6 fw-bold">Common <span className="text-magenta">Inquiries</span></h2>
              <p className="text-muted mt-3">
                Can't find what you're looking for? Reach out to our 
                <a href="mailto:support@cybersoftdev.com" className="text-magenta fw-bold text-decoration-none"> Support Center</a>.
              </p>
            </div>

            <div className="custom-accordion" id="faqAccordion">
              {faqData.map((item, index) => (
                <div className="accordion-card mb-3" key={index}>
                  <div className="accordion-header" id={`heading${index}`}>
                    <button 
                      className="accordion-trigger collapsed" 
                      type="button" 
                      data-bs-toggle="collapse" 
                      data-bs-target={`#collapse${index}`}
                    >
                      <span className="q-number">0{index + 1}</span>
                      <span className="q-text">{item.question}</span>
                      <i className="bi bi-chevron-down icon-state"></i>
                    </button>
                  </div>
                  <div 
                    id={`collapse${index}`} 
                    className="accordion-collapse collapse" 
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body-content">
                      {item.answer}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}